import {
  Separator,
  ToggleGroup,
  ToggleGroupItem,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shortsworks/ui";
import { startTransition, useEffect, useTransition } from "react";
import {
  InspectorTabItem,
  InspectorTabs,
} from "@app/components/WidgetStudio/Inspector/contracts/inspectorTabs";

interface InspectorHeaderProps {
  inspectorType: string;
  onInspectorTypeChange: (value: string) => void;
}

export const InspectorHeader = ({
  inspectorType,
  onInspectorTypeChange,
}: InspectorHeaderProps) => {
  const handleValueChange = (value: string) => {
    return startTransition(() => {
      onInspectorTypeChange?.(value);
    });
  };

  return (
    <div className="flex flex-shrink-0 h-14 items-center justify-center border-b mx-4">
      <TooltipProvider delayDuration={0}>
        <ToggleGroup
          type="single"
          size="sm"
          variant="outline"
          value={inspectorType}
          onValueChange={handleValueChange}
        >
          {InspectorTabs.map((tabItem: InspectorTabItem, index: number) => {
            if (tabItem.type === "separator") {
              return (
                <Separator
                  key={`inspector-tab-sp-${index}`}
                  orientation="vertical"
                  className="h-8"
                />
              );
            }

            return (
              <Tooltip key={tabItem.id}>
                <TooltipTrigger
                  value={tabItem.id}
                  asChild
                  data-state={tabItem.id === inspectorType ? "on" : "off"}
                >
                  <ToggleGroupItem value={tabItem.id}>
                    <tabItem.icon className="h-4 w-4" />
                  </ToggleGroupItem>
                </TooltipTrigger>
                <TooltipContent>{tabItem.label}</TooltipContent>
              </Tooltip>
            );
          })}
        </ToggleGroup>
      </TooltipProvider>
    </div>
  );
};
